import React, { useMemo } from 'react'

import { MainContent } from '@campaignhub/suit-theme'

import useMainNavigation from '@hooks/useMainNavigation'

import LoggedInUser from '@components/TopBar/components/LoggedInUser'
import MainNavigation from '@sections/Client/components/MainNavigation'
import Search from '@components/TopBar/components/Search'
import TopBar from '@components/TopBar'

import CampaignRoutes from './routes'

import Navigation from './components/Navigation'

const Campaign = () => {
  const { callbacks: { toggleNavigation } } = useMainNavigation()

  return (
    <>
      <TopBar
        callbacks={{ toggleNavigation }}
        loggedInUserComponent={<LoggedInUser />}
        nestedNavigation
        searchComponent={<Search callbacks={{ search: null }} />}
      />

      <MainNavigation minimized nestedNavigation={<Navigation />} />

      <MainContent nestedNavigation offset={{ top: TopBar.topBarHeight }}>
        <CampaignRoutes />
      </MainContent>
    </>
  )
}

export default Campaign
